import { useTranslation } from 'react-i18next';

type UseVersionDataReturnType = {
  versionData: { label: string; value: string }[];
};

export const useVersionData = (): UseVersionDataReturnType => {
  const { t } = useTranslation('venueDetails');

  const versionOptions = [
    'FULL_HOUSE',
    'UPPER_TIER_CLOSED',
    'CUT_DOWN',
    'FULLY_SEATED',
    'GA_FLOOR_SEATS_TRIBUNE',
  ] as const;

  const versionData = versionOptions.map((option) => ({
    label: t(`CONFIGURATION_VERSIONS.${option}`, { ns: 'venueDetails' }),
    value: option,
  }));

  return { versionData };
};
